//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, Tooltip, useTheme } from '@mui/material'
import React, { ReactElement } from 'react'

// const ViewItem = styled(Box)(({ theme }) => ({
//   ...theme.typography.body2,
//   textAlign: 'left',
//   backgroundColor: 'red',
//   color: theme.palette.text.secondary,
//   height: 60,
//   // borderWidth: 0,
//   // boxShadow: '0px 0px 0px 0px rgb(0 0 0 / 20%)',
//   // boxShadow: '2px 2px 1px 1px rgb(0 0 0 / 20%)',
//   lineHeight: '60px'
// }))

function ViewItem(props: { children: any; toolTip?: string }): ReactElement {
  const theme = useTheme()

  const Wrapper = ({ children }: { children: any }): ReactElement => {
    if (props.toolTip) return <Tooltip title={props.toolTip}>{children}</Tooltip>
    else return <>{children}</>
  }

  return (
    <Wrapper>
      <Box
        sx={{
          display: 'block',
          textAlign: 'left',
          minWidth: '100%',
          backgroundColor: theme.palette.background.paper,
          flexGrow: 1,
          margin: 0,
        }}
      >
        {props.children}
      </Box>
    </Wrapper>
  )
}

export default ViewItem
